import React from "react";
import LauoutSignup from "../lauoutSignup";
import FormOrgSignUp from "./FormOrgSignUp";

export default function CreateOrg() {
  return (
    <LauoutSignup>
      <FormOrgSignUp haveAccount={true} />
    </LauoutSignup>
  )
}
